module.exports = __webpack_public_path__ + "static/media/Create.1531d956.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Icons/Create.svg
// module id = 248
// module chunks = 0